import React from 'react';
import CalendarItem from './CalendarItem';
import EventsCategoriesInsideDates from './EventsGroupedByDate';
import { OrderCategories } from './EventsHierarchy';
import DateReplacements from 'components/Dashboard/UpcomingEvents/DatesReplacements';
import ContentTypeBadge from 'components/Dashboard/components/ContentTypeBadge';
import time from 'utils/time';

const UpcomingEventItem = ({
  eventsToShow,
  date,
  widgetEmbed,
  keywordListId,
  customKeywords,
  showContentTypeBadge,
}) => {
  const categoriesNames = Object.keys(eventsToShow);
  const categoriesToShow = OrderCategories(categoriesNames);
  const [commonCategoriesToShow, lordsCategoriesToShow, announcementsCategoriesToShow] = categoriesToShow;

  const dateToShow = (date) => {
    let dateReplacement = DateReplacements(date);
    if (dateReplacement === null) {
      return `${time(time.getCalendarDateKey(date)).formatWeekdayShortDate()}`;
    } else {
      return dateReplacement;
    }
  };
  const singleEvent = categoriesToShow.flat().length === 1;

  return singleEvent && !showContentTypeBadge ? (
    <div className='search-event-container'>
      <div className={`search-calendar-item mb-4 px-4 py-3`}>
        {!showContentTypeBadge && <h3 className='search-calendar-date'>{dateToShow(date)}</h3>}
        <div>
          {renderItem({
            events: eventsToShow,
            content: categoriesToShow.flat(),
            widgetEmbed,
            keywordListId,
            customKeywords,
            showContentTypeBadge: showContentTypeBadge,
            singleEvent,
          })}
        </div>
      </div>
    </div>
  ) : (
    <div className='search-event-container'>
      <div className={`search-calendar-item mb-4 ${showContentTypeBadge ? 'px-4 py-3' : 'p-4'}`}>
        <div className={`${showContentTypeBadge ? '' : 'content-item'}`}>
          {showContentTypeBadge && (
            <div className='mt-1 specific-bottom-margin-14 flex-grow-1 text-light-blue blue-icon content-type-badge'>
              <ContentTypeBadge
                objectType={'UpcomingEvents'}
                name={singleEvent ? 'Upcoming event' : 'Upcoming events'}
              />
            </div>
          )}
          {!showContentTypeBadge && <h3 className='search-calendar-date'>{dateToShow(date)}</h3>}
          <div className='position-relative' style={{ zIndex: 3 }}>
            {renderItem({
              events: eventsToShow,
              content: commonCategoriesToShow,
              mainCategory: 'commons',
              widgetEmbed,
              keywordListId,
              customKeywords,
              showContentTypeBadge: showContentTypeBadge,
            })}
          </div>
          <div className='position-relative' style={{ zIndex: 2 }}>
            {renderItem({
              events: eventsToShow,
              content: lordsCategoriesToShow,
              mainCategory: 'lords',
              widgetEmbed,
              keywordListId,
              customKeywords,
              showContentTypeBadge: showContentTypeBadge,
            })}
          </div>
          <div className='position-relative' style={{ zIndex: 1 }}>
            {renderItem({
              events: eventsToShow,
              content: announcementsCategoriesToShow,
              announcementsCategoriesToShow,
              mainCategory: 'announcements',
              widgetEmbed,
              keywordListId,
              customKeywords,
              showContentTypeBadge: showContentTypeBadge,
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

const renderItem = ({
  events,
  content,
  mainCategory,
  widgetEmbed,
  keywordListId,
  customKeywords,
  showContentTypeBadge,
  singleEvent,
}) => {
  return (
    <>
      {content.length > 0 && (
        <>
          {content.map((item, index, array) => {
            return (
              <>
                <div
                  className='calendar-category-container position-relative'
                  key={`${mainCategory}-${index}`}
                  style={{ zIndex: array.length - index }}
                >
                  {!showContentTypeBadge && (
                    <h4 className={`calendar-category calendar-category-${mainCategory}`}>{item}</h4>
                  )}
                  {events[item].map((event, index, arr) => (
                    <CalendarItem
                      key={`event${index}`}
                      item={event}
                      index={index}
                      array={arr}
                      widgetEmbed={widgetEmbed}
                      keywordListId={keywordListId}
                      customKeywords={customKeywords}
                      showContentTypeBadge={showContentTypeBadge}
                      eventLocation={item}
                      singleEvent={singleEvent}
                    />
                  ))}
                </div>
              </>
            );
          })}
        </>
      )}
    </>
  );
};

const renderElements = (eventsToShow, widgetEmbed, keywordListId, customKeywords) => {
  const items = [];
  for (var i in eventsToShow) {
    items.push(
      <UpcomingEventItem
        key={`event${i}`}
        eventsToShow={eventsToShow[i]}
        date={i}
        widgetEmbed={widgetEmbed}
        keywordListId={keywordListId}
        customKeywords={customKeywords}
      />
    );
  }
  return items;
};

const createCalendarRenderElements = ({ elements, feedItemFlags }) => {
  const eventsToShow = EventsCategoriesInsideDates(elements, feedItemFlags);
  return renderElements(eventsToShow);
};

export { createCalendarRenderElements, renderItem, UpcomingEventItem };
export default renderElements;
